import { useState } from "react"

import { Currency as CurrencyResponse } from "modules/Booking/common/interfaces"
import {
    createdBookingLoader,
    createdDepositLoader,
    createdTimeRequestLoader,
} from "modules/BookingCommon/common/queries"
import { PaymentSystemType } from "utils/interfaces"
import { readSearchParams } from "utils/customHooks"
import { httpClient } from "utils/infrastructure/httpClient"
import { CURRENCY } from "utils/constants"

export const useCurrency = () => {
    const orderHash = readSearchParams().get("order_hash") ?? undefined
    const bookingHash = createdBookingLoader.getHash()
    const timeRequestHash = createdTimeRequestLoader.getHash()
    const depositHash = createdDepositLoader.getHash()
    const { data: bookingDetails } = createdBookingLoader.useGet(bookingHash)

    const [currency, setCurrency] = useState<CURRENCY>(
        bookingDetails?.payment_system === PaymentSystemType.STRIPE ? CURRENCY.USD : CURRENCY.RUB
    )

    const updateCurrency = async () => {
        try {
            const { payment_system, price_usd } = await httpClient.post<CurrencyResponse>(
                "order/currency",
                {
                    order_hash: orderHash,
                    currency,
                }
            )

            if (bookingHash) {
                createdBookingLoader.updateData(bookingHash, { payment_system, price_usd })
            } else if (timeRequestHash) {
                createdTimeRequestLoader.updateData(timeRequestHash, {
                    payment_system,
                    price_usd,
                })
            } else if (depositHash) {
                createdDepositLoader.updateData(depositHash, { payment_system, price_usd })
            }
            return { payment_system }
        } catch (error) {
            window.location.reload()
        }
    }

    return {
        currency,
        setCurrency,
        updateCurrency,
    }
}
